module.exports = __webpack_public_path__ + "media/audio65.27bfd2fe.mp3";